<template>
  <v-btn :icon="name" variant="text" :disabled="disabled" @click="toggleExpand" />
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    isExpanded: {
      type: Boolean,
      required: false,
    },

    isLink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    name() {
      if (this.isLink) return 'mdi-chevron-right';
      return this.isExpanded ? '$expand-less' : '$expand-more';
    },
  },

  methods: {
    toggleExpand() {
      this.$emit('expand');
    },
  },
};
</script>
